module.exports = __webpack_public_path__ + "static/media/baseline-people.c6739ff0.svg";